import * as React from "react";
import Alert from "../Alert.jsx";
import Box from "@mui/material/Box";
import { useFlash } from "../FlashContext";

const FlashMessage = () => {
  const { messages, dismissToast } = useFlash();
  const timersRef = React.useRef<Record<string, NodeJS.Timeout>>({});
  const messageIds = React.useRef<Set<string>>(new Set());

  React.useEffect(() => {
    const currentIds = new Set(messages.map((m) => m.id));
    Object.keys(timersRef.current).forEach((id) => {
      if (!currentIds.has(id)) {
        clearTimeout(timersRef.current[id]);
        delete timersRef.current[id];
      }
    });

    messages.forEach((msg) => {
      const duration = msg.autoHideDuration;
      if (typeof duration === "number" && duration > 0 && !timersRef.current[msg.id]) {
        timersRef.current[msg.id] = setTimeout(() => {
          dismissToast(msg.id);
          delete timersRef.current[msg.id];
        }, duration);
      }
    });

    messageIds.current = currentIds;
  }, [messages, dismissToast]);

  return (
    <Box
      sx={{
        position: "fixed",
        top: 16,
        right: 16,
        zIndex: 1400,
        width: "clamp(240px, 90vw, 480px)",
        pointerEvents: "none",
      }}
    >
      {/* Vertical stack */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1, // spacing between toasts
        }}
      >
        {messages.map((message, index) => {
          const isTopToast = index === 0;

          return (
            <Box
              key={message.id}
              sx={{
                pointerEvents: "auto",
              }}
            >
              <Alert
                message={message}
                onClose={() => dismissToast(message.id)}
                isTopToast={isTopToast}
              />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default FlashMessage;
